<template>
  <div>
    <van-cell-group title="筛选">
      <van-cell
        title="审核状态"
        :value="state.val"
        @click="state.show = true"
        is-link
      />
      <van-popup v-model="state.show" round position="bottom">
        <van-picker
          :columns="state.list"
          show-toolbar
          @cancel="state.show = false"
          @confirm="changeState"
          value-key="label"
        />
      </van-popup>
      <van-cell
        title="选择日期"
        :value="date.val"
        @click="date.show = true"
        is-link
      />
      <van-calendar
        v-model="date.show"
        type="range"
        @confirm="changeDate"
        :allow-same-day="true"
        :min-date="date.minDate"
      />
    </van-cell-group>
    <van-empty description="暂无数据" v-if="list.datas.length == 0" />
    <div v-else>
      <van-notice-bar
        left-icon="volume-o"
        text="直接点击记录，可以看详情和审批处理。"
      />
      <van-list
        :finished="list.finish"
        @load="loadPage"
        v-model="list.loading"
        :immediate-check="false"
        style="padding: 10px 0px"
      >
        <div
          class="wcard"
          v-for="data in list.datas"
          :key="data.id"
          @click="getDetail(data.id)"
        >
          <div class="bd">
            <van-row :gutter="8">
              <van-col :span="24">
                <div v-for="title in list.titles" :key="title.key" class="text">
                  <span class="label">{{ title.label }}：</span>
                  <template v-if="title.tag != 'el-upload'">
                    {{ data[title.key] }}
                  </template>
                  <template v-else>
                    <template
                      v-for="(up, upIndex) in JSON.parse(data[title.key])">
                      <a
                        :key="'file_' + upIndex"
                        :href="up.realsrc"
                        :download="up.name"
                        >{{ up.name }}</a
                      >
                    </template>
                  </template>
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import { Toast } from "vant";

export default {
  name: "list",
  data() {
    return {
      ignoreKeys: ["id"],
      queryData: {
        SearchKeys: this.$route.params.SearchKeys,
        formKey: this.$route.params.formKey,
        starT_DATE: "",
        enD_DATE: "",
        _curPage: 0,
        _pageSize: 12,
      },
      state: {
        show: false,
        list: [],
      },
      date: {
        show: false,
        minDate: new Date(),
        val: "",
      },
      list: {
        finish: false,
        titles: [],
        datas: [],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.queryData.SearchKeys == "sp") {
        this.state.list = [
          { value: 0, label: "待审批" },
          { value: 1, label: "已审批" },
        ];
        this.queryData.search_SEA_STATE = this.state.list[0].value;
      } else {
        this.state.list = [
          { value: 0, label: "全部" },
          { value: 1, label: "已审核" },
          { value: 2, label: "未审核" },
        ];
        this.queryData.seA_STATE = this.state.list[0].value;
      }
      this.state.val = this.state.list[0].label;
      this.getList();
    },
    changeState(val) {
      if (this.queryData.SearchKeys == "sp") {
        this.queryData.search_SEA_STATE = val.value;
      } else {
        this.queryData.seA_STATE = val.value;
      }
      this.state.show = false;
      this.state.val = val.label;
      this.filter();
    },
    changeDate(d) {
      this.queryData.starT_DATE = moment(d[0]).format("YYYY-MM-DD");
      this.queryData.enD_DATE = moment(d[1]).format("YYYY-MM-DD");
      this.date.show = false;
      this.date.val =
        this.queryData.starT_DATE + " 至 " + this.queryData.enD_DATE;
      this.filter();
    },
    getList() {
      let self = this;
      self.queryData.loading = true;
      this.whale.remote.getResult({
        url: "/api/api/flow-form-data/page",
        data: this.queryData,
        completed: function ({ ResultType, Message, AppendData }) {
          self.queryData.loading = false;
          if (ResultType == 0) {
            self.list.titles = AppendData.Titles;
            self.list.datas.push(...AppendData.datas.ITEMS);
            if (self.list.datas.length >= AppendData.datas.TOTAL) {
              self.list.finish = true;
            }
            console.log(self.list);
          } else {
            Toast.fail(Message);
          }
        },
      });
    },
    loadPage() {
      this.queryData._curPage += 1;
      this.getList();
    },
    filter() {
      this.list.datas = [];
      this.list.finish = false;
      this.list.loading = false;
      this.queryData._curPage = 0;
      this.getList();
    },
    getDetail(id) {
      this.$router.push({
        path: "/apply/detail?id=" + id + "&formKey=" + this.queryData.formKey,
      });
    },
  },
};
</script>

<style scoped>
.wcard {
  padding: 10px 0;
  margin: 0 12px 12px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}

.wcard .ft {
  border-top: 1px dashed #ebedf0;
  padding: 8px 16px;
  font-size: 12px;
  min-height: 20px;
}

.wcard .ft .ov {
  color: #ee0a24;
  font-weight: bold;
}

.wcard .bd {
  padding: 0px 15px;
}

.wcard .bd .lf {
  text-align: center;
  color: #ee0a24;
  padding-top: 10px;
}

.wcard .bd .lf h2 {
  font-size: 30px;
  font-weight: 500;
  display: inline;
}

.wcard .bd .lf span {
  font-size: 40%;
  font-weight: normal;
  margin-left: 2px;
}

.wcard .bd .lf p {
  font-size: 14px;
  line-height: 16px;
}

.wcard .text {
  padding: 2px 0px;
  font-size: 14px;
  color: #999;
  word-break: break-all;
}

.wcard .text .label {
  color: #333;
}
</style>